module.exports = __webpack_public_path__ + "static/media/platform_4.7ed7be79.svg";